import type { Collection } from '../../../collection'
import type * as ecModels from '../../../models'
import type * as plugin from '../../plugin'

import { Plugin } from './plugin'

/**
 * {@link plugin.Plugin.Factory} for this {@link Plugin}
 * ({@link plugin.Plugin.Id.Standard.ApiExecution})
 */
export class Factory<TTypeParams extends ecModels.TypeParams.Constraint>
  implements
    plugin.Plugin.Factory<
      TTypeParams,
      plugin.Plugin.Id.Standard.ApiExecution,
      Plugin<TTypeParams>
    >
{
  /** @see {@link plugin.Plugin.Factory.id} */
  public readonly id = Plugin.Id.Standard.ApiExecution

  /** @see {@link plugin.Plugin.Factory.produceFor} */
  public produceFor(collection: Collection<TTypeParams>): Plugin<TTypeParams> {
    return new Plugin({ collection })
  }
}
